<template>
  <div>
    <card v-if="!this.loading">
      <referrer-user-admin-panel :referrerUser="this.itemProp"
                                 :key="update_key_switch_admin_panel"/>

    </card>
    <div v-if="this.loading">
      <div class="spinner-grow" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
    import {refreshIdToken} from '../util/utilsYsy'
    import ReferrerUserAdminPanel from "./ysy/ReferrerUserAdminPanel";

    export default {
        name: 'GetLicensesKey',
        components: {
            ReferrerUserAdminPanel,
        },
        data() {
            return {
                itemProp: [],
                update_key_switch_admin_panel: '',
                monthToDisplay: '1',
                loading: true,
                data: [],
                headers: [],
                tmp_user_for_modal_deactivate: '',
            };
        },
        created() {
            this.init_list_user()
        },
        methods: {
            async init_list_user() {
                const path = this.BACKEND_YSY + "/admin/get-licenses-by-referrer";
                let headers = {
                    'Content-type': 'application/json',
                    'Authorization': `Bearer ${localStorage.id_token}`
                };
                await this.$http
                    .post(path, {
                        referrer: this.$store.state.referrer
                    }, {headers})
                    .then(res => {
                        console.log(res);
                        this.itemProp = res.data;
                        this.update_key_switch_admin_panel = Date.now()
                        this.loading = false
                    })
                    .catch(async error => {
                        const self = this;
                        if (error.response.status === 401) {
                            console.error('Unauthorized', error.response.data);
                            await this.refreshIdToken().then(function (result) {
                                console.log("res promise", result); // "Stuff worked!"
                                self.init_list_user()
                            }, function (err) {
                                console.log("it broke", err); // Error: "It broke"
                                self.$router.push({name: 'login'});
                            });
                        }
                    });
            },
            refreshIdToken,
        }
    }
</script>
